import React, { useEffect, useRef } from 'react';
import './Portfolio.css';
import RevealOnScroll from './RevealOnScroll';

const projects = [
  {
    image: "https://aibridze.com/wp-content/uploads/2025/04/intro-top-bg-min.png",
    text: "",
    size: "small"
  },
  {
    image: "https://aibridze.com/wp-content/uploads/2024/12/about-us-bg-1-min.jpg",
    text: "Creative",
    size: "large"
  },
  {
    image: "https://aibridze.com/wp-content/uploads/2025/03/image-450-min.jpg",
    text: "",
    size: "medium"
  },
  {
    image: "https://aibridze.com/wp-content/uploads/2025/03/image-530-min.jpg",
    text: "Solutions",
    size: "large"
  },
  {
    image: "https://aibridze.com/wp-content/uploads/2025/01/home-2-subscribe-bg.jpg",
    text: "",
    size: "medium"
  }
];

const Portfolio = () => {
  const scrollRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (scrollRef.current) {
        const scrolled = window.scrollY;
        // Translate the track leftward dynamically based on scroll position
        scrollRef.current.style.transform = `translateX(-${scrolled * 0.3}px)`;
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="portfolio-section" id="portfolio">
      <div className="portfolio-scroll-container">
        <div className="portfolio-track" ref={scrollRef}>
          {/* Render real projects */}
          {projects.map((project, index) => (
            <RevealOnScroll key={index} delay={index * 100}>
              <div className={`portfolio-card ${project.size}`}>
                <img src={project.image} alt="Portfolio item" className="portfolio-img" />
                {project.text && (
                  <div className="portfolio-rotated-text">
                    {project.text}
                  </div>
                )}
              </div>
            </RevealOnScroll>
          ))}
          {/* Render duplicates to ensure the track seems infinite/long enough */}
          {projects.map((project, index) => (
            <div key={`dup-${index}`} className={`portfolio-card ${project.size}`}>
              <img src={project.image} alt="Portfolio item" className="portfolio-img" />
              {project.text && (
                <div className="portfolio-rotated-text">
                  {project.text}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
